import React from 'react';
import { Heading, Layout, Text } from '../../../../components/core';
import { IconBookmark } from '../../../../components/icons/IconBookmark';
import { HubSurveyResultResource } from '../../../../graphQL';
import { getStylesheet } from '../../../../styles';
import { BookmarkApi } from '../SurveyResultsPage';
import { ResourceCard } from './RecommendationArea';

export const SavedResources = ({
  bookmarkedResources,
  bookmarkApi,
}: {
  bookmarkedResources: HubSurveyResultResource[];
  bookmarkApi: BookmarkApi;
}): JSX.Element => {
  const headerId = 'saved-resources-header';
  const hasSaved = bookmarkedResources.length > 0;
  const headingText = hasSaved
    ? `Your Saved Resources (${bookmarkedResources.length})`
    : 'Save resources to create your own resource library';

  return (
    <Layout.VStack
      {...styles.savedResourcesContainer}
      space={4}
      aria-labelledby={headerId}
      role="region"
    >
      <Layout.VStack space={1}>
        <Layout.HStack space={2} alignItems="center">
          <IconBookmark {...styles.bookmarkIcon} aria-hidden size={6} />

          <Layout.VStack space={1} {...styles.textColumn}>
            <Heading.h5 id={headerId} level={2}>
              {headingText}
            </Heading.h5>

            <Text.caption>
              Bookmark the resources that feel most relevant to you for quick access later
            </Text.caption>
          </Layout.VStack>
        </Layout.HStack>
      </Layout.VStack>

      {hasSaved && (
        <Layout.VStack space={4} role="list" aria-label="Saved resource list">
          {bookmarkedResources.map(resource => (
            <ResourceCard
              key={resource.id}
              resource={resource}
              // recommendationAreaId intentionally omitted in saved list context
              bookmarkApi={bookmarkApi}
            />
          ))}
        </Layout.VStack>
      )}
    </Layout.VStack>
  );
};

const styles = getStylesheet({
  bookmarkIcon: {
    alignSelf: 'start',
  },
  savedResourcesContainer: {
    backgroundColor: 'rgba(43,89,227,0.05)', // blue.600 @ 5% opacity
    borderColor: 'primary.300',
    borderWidth: 1,
    borderStyle: 'dashed',
    borderRadius: 16,
    padding: 6,
    marginBottom: 8,
  },
  textColumn: {
    flex: 1,
  },
});
